<template>
  <div>
    <article class="slds-card slds-card_boundary">
      <div class="slds-card__header slds-grid">
        <header class="slds-media slds-media_center slds-has-flexi-truncate">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-standard-filter">
            <svg class="slds-icon slds-icon-action-filter" aria-hidden="true">
              <use xlink:href="../../assets/symbols.svg#filterList"></use>
            </svg>
          </span>
          </div>
          <div class="slds-media__body">
            <h2 class="slds-card__header-title">
              <span href="javascript:void(0);" class="slds-card__header-link slds-truncate" title="Accounts">
                {{$t('campaignDesigner.campaignsList.filters')}}
              </span>
            </h2>
          </div>
          <div class="slds-no-flex">
            <button class="slds-button slds-button_neutral" @click="applyFilters">{{$t('action.applyFilters')}}</button>
          </div>
        </header>
      </div>
      <div class="slds-card__body slds-card__body_inner">
        <div class="row">
          <div class="slds-form-element">
            <SLDSInput
              :label="$t('campaignDesigner.campaignsList.campaignName')"
              :placeholder="$t('action.filter')"
              has-left-icon
              type="text"
              v-model="localSearchKey">
                <use xlink:href="../../assets/symbols.svg#search" slot="leftIcon"></use>
            </SLDSInput>
          </div>
          <div class="slds-form-element">
            <Picklist
              :label="$t('campaignDesigner.campaignsList.status.label')"
              :options="settings.campaignStatus"
              multipicklist
              include-all-value
              labels-prefix="campaignDesigner.campaignsList.status"
              v-if="settings.campaignStatus.length"
              v-model="status" />
          </div>
        </div>
        <div class="row">
          <div class="slds-form-element">
            <SLDSInput
              :label="$t('campaignDesigner.campaignsList.startDate')"
              :min="new Date('2024-01-01')"
              :max="this.endDate?this.endDate:null"
              type="date"
              v-model="startDate" />
          </div>
          <div class="slds-form-element">
            <SLDSInput
              :label="$t('campaignDesigner.campaignsList.endDate')"
              :min="this.startDate?this.startDate:new Date('2024-01-01')"
              type="date"
              v-model="endDate" />
          </div>
          <div>
            <Picklist
              :label="$t('campaignDesigner.campaignsList.type.label')"
              :options="settings.campaignTypes"
              include-all-value
              v-if="settings.campaignTypes.length"
              v-model="localType" />
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import _ from 'lodash'
import Picklist from '../../components/slds/Picklist'
import SLDSInput from '../../components/slds/Input'
export default {
  components: {
    Picklist,
    SLDSInput
  },
  props: {
    searchKey: String,
    type: String,
    value: Object
  },
  async created () {
    this.settings = await this.$store.dispatch('settings/getSettings')
    const types = this.settings.campaignTypes
      .map(type => {
        return {
          label: `${this.$t('departments.' + type.department)} - ${type.name}`,
          value: type.name
        }
      })
      .sort((option1, option2) => option1.label.localeCompare(option2.label))

    this.settings.campaignTypes = _.uniqBy(types, 'value')
    this.localSearchKey = this.searchKey
    this.status = this.value.status
    this.type = this.value.type
    this.endDate = this.value.endDate
    this.startDate = this.value.startDate
  },
  data () {
    return {
      settings: {
        campaignStatus: [],
        campaignTypes: []
      },
      endDate: '',
      localSearchKey: '',
      startDate: '',
      status: [],
      localType: ''
    }
  },
  methods: {
    async applyFilters () {
      await this.$emit('filterButtonClick')
    }
  },
  watch: {
    endDate () {
      this.$emit('input', { endDate: this.endDate, localSearchKey: this.localSearchKey, startDate: this.startDate, status: this.status, type: this.type })
    },
    localSearchKey () {
      this.$emit('changeSearchKey', { value: this.localSearchKey })
    },
    searchKey (searchKey) {
      this.localSearchKey = searchKey
    },
    startDate () {
      this.$emit('input', { endDate: this.endDate, localSearchKey: this.localSearchKey, startDate: this.startDate, status: this.status, type: this.type })
    },
    status () {
      this.$emit('input', { endDate: this.endDate, localSearchKey: this.localSearchKey, startDate: this.startDate, status: this.status, type: this.type })
    },
    localType (value) {
      this.$emit('changeType', { value })
    },
    value (value) {
      this.status = this.value.status
      this.type = this.value.type
      this.endDate = this.value.endDate
      this.startDate = this.value.startDate
    }
  }
}
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    /*align-items: flex-end;*/

    & .slds-form-element {
      flex-grow: 1;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
</style>
